module.exports = __webpack_public_path__ + "img/1.ee5a47c6.png";